import React from "react";
import instagram from "../../resources/instagram.png";
import facebook from "../../resources/facebook.png";

export const Footer = () => {
    return (
        <div className="w-full bg-stone-900 border-t border-stone-800">
            <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 py-10 px-6">

                <div className="flex flex-col items-center">
                    <p className="font-serif text-xs uppercase tracking-widest text-[#C29979] mb-4">Fylgdu okkur</p>
                    <div className="flex gap-3">
                        <a href="https://www.facebook.com/kallabakari" target="_blank" rel="noopener noreferrer">
                            <img src={facebook} alt="facebook" className="w-10 h-10 rounded-full bg-white/10 p-1.5 hover:bg-[#C29979]/30 transition-colors" />
                        </a>
                        <a href="https://www.instagram.com/kallabakari" target="_blank" rel="noopener noreferrer">
                            <img src={instagram} alt="instagram" className="w-10 h-10 rounded-full bg-white/10 p-1.5 hover:bg-[#C29979]/30 transition-colors" />
                        </a>
                    </div>
                </div>

                <div className="flex flex-col items-center text-center">
                    <p className="font-serif text-xs uppercase tracking-widest text-[#C29979] mb-3">Opnunartímar</p>
                    <p className="font-serif text-sm text-stone-300 mb-1">Mánudaga – Föstudaga: 07:00 – 17:00</p>
                    <p className="font-serif text-sm text-stone-300 mb-1">Laugardaga: 08:00 – 16:00</p>
                    <p className="font-serif text-sm text-stone-300">Sunnudaga: 09:00 – 16:00</p>
                </div>

                <div className="flex flex-col items-center text-center">
                    <p className="font-serif text-xs uppercase tracking-widest text-[#C29979] mb-3">Hafðu samband</p>
                    <p className="font-serif text-sm text-stone-300 mb-1">Símanúmer: 431-1644</p>
                    <p className="font-serif text-sm text-stone-300">kallabakari@kallabakari.is</p>
                </div>

            </div>
            <div className="border-t border-stone-800 py-4 text-center">
                <p className="font-serif text-xs text-stone-600">© Kallabakarí · Innnesvegur 1 · Akranes</p>
            </div>
        </div>
    );
};

export default Footer;
